module.exports = __webpack_public_path__ + "static/media/campus_28.e7dd9934.png";